// src/pages/ChartPage.js
import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { chartMap } from '../components/ChartMap';
import { Typography, Box, Paper } from '@mui/material';

const ChartPage = () => {
    const { chartSlug } = useParams();
    const chartEntry = Object.values(chartMap).find(c => c.slug === chartSlug);

    if (!chartEntry) {
        return <Navigate to="/" replace />;
    }

    const ChartComponent = chartEntry.component;

    return (
        <Box>
            <Typography variant="h1">
                {chartEntry.label}
            </Typography>
            <Paper variant='section'>
                <ChartComponent />
            </Paper>
        </Box>
    );
};


export default ChartPage;
